import Vue from 'vue'
import Router from 'vue-router'
import Horoscope from '@/components/mobiscope/Horoscope.vue'
import Tarot from '@/components/mobiscope/Tarot.vue'
import Zodiac from '@/components/mobiscope/Zodiac.vue'
import Profile from '@/components/mobiscope/Profile.vue'
import ChineseZodiac from '@/components/mobiscope/ChineseZodiac.vue'
import Login from '@/components/authentication/mobiscope/Login.vue'
import HoroscopeDetails from '@/components/mobiscope/HoroscopeDetails.vue'
import ZodiacDetails from '@/components/mobiscope/ZodiacDetails.vue'
import ElementsDetails from '@/components/mobiscope/ElementsDetails.vue'
import ChineseZodiacDetails from '@/components/mobiscope/ChineseZodiacDetails.vue'
import PrivacyPolicy from "../components/mobiscope/PrivacyPolicy.vue";
import Terms from "../components/mobiscope/Terms.vue"
Vue.use(Router);

export default new Router({
    mode: 'history',
    hash: false,
    history: true,
    routes: [
        {
            path: '/',
            name: 'Horoscope',
            component: Horoscope,
            children: [{
                path: '/horoscope',
                path: '/horoscope/:id'
            }]
        },
        // {
        //     path: '/horoscope',
        //     name: 'Horoscope',
        //     component: Horoscope,
        //     children: [{
        //         path: '/horoscope/:id'
        //     }]
        // },
        {
            path: '/horoscope-sign/:sign',
            name: 'HoroscopeDetails',
            component: HoroscopeDetails,
            children: [{
                path: '/horoscope-sign/:sign/:id'
            }]
        },
        {
            path: '/tarot*',
            name: 'Tarot',
            component: Tarot,
            children: [{
                path: '/tarot/:id'
            }]
        },
        {
            path: '/zodiac*',
            name: 'Zodiac',
            component: Zodiac,
            children: [{
                path: '/zodiac/:id'
            }]
        },
        {
            path: '/chinesezodiac',
            name: 'ChineseZodiac',
            component: ChineseZodiac,
            children: [{
                path: '/chinesezodiac/:id'
            }]
        },
        {
            path: '/zodiac-sign/:zodiac',
            name: 'ZodiacDetails',
            component: ZodiacDetails,
            children: [{
                path: '/zodiac-sign/:zodiac/:id'
            }]
        },
        {
            path: '/element-sign/:element',
            name: 'ElementsDetails',
            component: ElementsDetails,
            children: [{
                path: '/element-sign/:element/:id'
            }]
        },
        {
            path: '/chinese-sign/:chinesesign',
            name: 'ChineseZodiacDetails',
            component: ChineseZodiacDetails,
            children: [{
                path: '/chinese-sign/:chinesesign/:id'
            }]
        },
        {
            path: "/privacy",
            name: "PrivacyPolicy",
            component: PrivacyPolicy,
            children: [
              {
                path: "/privacy/:token"
              }
            ]
          },
        {
            path: "/terms",
            name: "Terms",
            component: Terms,
            children: [
                {
                path: "/terms/:token"
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            children: [
                {
                    path: "/logout"
                }
            ]
        },
        {
            path: "/profile",
            name: "Profile",
            component: Profile,
            children: [
                    {
                    path: "/profile/:token"
                    }
            ]
          },
        //if have param id
        {
            path: '/:id',
            name: 'Horoscope',
            component: Horoscope,
        }
        
    ]
  })


// WEBPACK FOOTER //
// ./src/router/mobiscope.js